import React, { useEffect } from "react"

// assets
import bannerImage from "../assets/img/Home/banner.png";
import aboutImg from "../assets/img/Home/aboutImg.png";
import whyImg1 from "../assets/img/Home/why-3.png";
import whyImg2 from "../assets/img/Home/why-2.png";
import whyImg3 from "../assets/img/Home/why-1.png";

// components
import MainBanner from "../components/Banners/MainBanner";
import HomeCategories from "../components/Home/HomeCategories";
import HomeProducts from "../components/Home/HomeProducts";
import useProducts from "../hooks/products/useProducts";
import useCategories from "../hooks/categories/useCategories";

const HomePage = () => {
    const { 
        products, 
        loading, 
        fetchProducts, 
        productsRecommended, 
        loadingRecommended, 
        fetchProductsRecommended 
    } = useProducts();

    useEffect(() => {
        fetchProducts({ limit: 4 });
        fetchProductsRecommended({ limit: 4 });
    }, []);
    
    const { 
        categories, 
        loadingCat, 
        fetchCategories 
    } = useCategories();

    useEffect(() => {
        fetchCategories({ page: 1, limit: 10 });
    }, []);

    return (
        <>
            <section className="section-mainBanner w-100">
                <MainBanner BannerImage={bannerImage} />
            </section>
            <section className="section-categories py-5">
                {loadingCat ? (
                    <>Cargando...</>
                ):(
                    <HomeCategories categories={categories} />
                )}
            </section>
            <section className="section-products pb-5">
                {!loading && products ? (
                    <HomeProducts products={products.products} title={"Nuevos productos"} description={"Productos nuevos todas las semanas para ti"} />
                ):(
                    <>Cargando...</>
                )}
                <div className="container">
                    <hr />
                </div>
            </section>
            <section className="section-products pb-5">
                {!loadingRecommended && productsRecommended ? (
                    <HomeProducts products={productsRecommended.products} title={"Recomendados para ti"} description={null} />
                ):(
                    <>Cargando...</>
                )}
            </section>
            <section className="section-about py-5">
                <div className="container">
                    <div className="col-lg-10 offset-lg-1 col-12">
                        <div className="row d-flex align-items-center">
                            <div className="col-md-5 col-12 d-md-block d-none pe-md-5">
                                <img className="w-100" src={aboutImg} alt="Gift" />
                            </div>
                            <div className="col-md-7 col-12">
                                <h2 className="mb-4">¿Qué es Alma de las Cosas?</h2>
                                <p>
                                    Somos un Marketplace que une lo mejor de dos mundos. Por un lado vendedores locales con una oferta autentica y original. Por otro lado compradores de todo el país que buscan productos únicos que no encontrarán en el supermercado más cercano. Todo en el Marco de la sostenibilidad tanto ambiental como económica.
                                    <br /> 
                                    <br /> 
                                    Si es un producto especial tiene alma, si tiene alma está aquí.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-why py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2>¿Por qué elegir a Alma?</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-12 px-md-4 px-3">
                            <div className="card-why">
                                <div className="card-why__header">
                                    <img src={whyImg1} alt="why" />
                                </div>
                                <div className="card-why__body">
                                    <h3>Máxima seguridad</h3>
                                    <p>Una plataforma 100% segura y mejoramiento continuo</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 px-md-4 px-3">
                            <div className="card-why">
                                <div className="card-why__header">
                                    <img src={whyImg2} alt="why" />
                                </div>
                                <div className="card-why__body">
                                    <h3>Envíos mega flash</h3>
                                    <p>Logística propia para entregar pedidos en cuestión de horas</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 px-md-4 px-3">
                            <div className="card-why">
                                <div className="card-why__header">
                                    <img src={whyImg3} alt="why" />
                                </div>
                                <div className="card-why__body">
                                    <h3>Comunidad inspirada en ti</h3>
                                    <p>Respetamos el planeta con piezas únicas producidas en pequeña escala</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default HomePage;